const PREFIX = 'EH_' // EverHealth prefix

export function setStorageItem<T>(key: string, value: T): void {
  try {
    const serialized = typeof value === 'string' ? value : JSON.stringify(value)
    localStorage.setItem(PREFIX + key, serialized)
  } catch (error) {
    console.warn(`No se pudo guardar en localStorage: ${key}`, error)
  }
}

export function getStorageItem<T>(key: string, parseJson: boolean = true): T | null {
  try {
    const item = localStorage.getItem(PREFIX + key)
    if (item === null) return null
    if (!parseJson) {
      return item as unknown as T
    }
    return JSON.parse(item) as T
  } catch (error) {
    console.warn(`Error leyendo localStorage: ${key}`, error)
    return null
  }
}

export function removeStorageItem(key: string): void {
  localStorage.removeItem(PREFIX + key)
}

export function clearEverhealthStorage(): void {
  Object.keys(localStorage)
    .filter((k) => k.startsWith(PREFIX))
    .forEach((k) => localStorage.removeItem(k))
}
